module.exports = __webpack_public_path__ + "img/images/new-landing/currency-icon-orange.svg?cc727d0a";